<template>
  <footer class="mt-auto p-5 border-t text-xxs font-mono">
    <span class="block mb-2 text-gray-500">2022 Landscape Monitor S.L.</span>
    <ul class="flex items-center space-x-4">
      <li v-for="link in legal" :key="link.url">
        <a
          :href="link.url"
          target="_blank"
          class="inline text-gray-700 hover:underline"
          >{{ link.label }}</a
        >
      </li>
    </ul>
  </footer>
</template>
<script>
export default {
  name: 'SidenavFooter',
  data() {
    return {
      legal: [
        {
          label: 'Terms of use',
          url: 'https://www.landscapemonitor.io/terms-of-use/'
        },
        {
          label: 'Privacy policy',
          url: 'https://www.landscapemonitor.io/privacy-policy'
        }
      ]
    }
  }
}
</script>
